/*
 * @providesModule PlayerLevelsScreen
 *
 */

import React from 'react';

import {_m} from 'INTL';
import AWSManager from 'AWSManager';
import ModalNavigationController from 'ModalNavigationController';
import NavigationBar from 'NavigationBar';
import PlayerLevelsListContainer from 'PlayerLevelsListContainer';
import Sizes from 'Sizes';
import SkillzStyle from 'SkillzStyle';
import SKZConstants from 'SKZConstants';
import HowToLevelUpModal from 'HowToLevelUpModal';
import Preferences from 'Preferences';
import SkillzRouter from 'SkillzRouter';

import {BackHandler, Platform, StyleSheet, View} from 'react-native';

const TEST_IDS = {
  PLAYER_LEVELS_SCREEN: 'player_levels_screen',
  PLAYER_LEVELS_SCREEN_NAVIGATION_BAR: 'player_levels_screen_navigation_bar',
  PLAYER_LEVELS_SCREEN_MODAL: 'player_levels_screen_modal',
};

type PlayerLevelsScreenProps = {
  userId: number | string;
  expandedCellOnOpen: number;
  onBack: () => void;
};

export default class PlayerLevelsScreen extends React.Component<PlayerLevelsScreenProps> {
  static defaultProps = {
    onBack: () => {
      SkillzRouter.back();
    },
    expandedCellOnOpen: SKZConstants.LevelsDefaultOpenCell.NO_LEVEL,
  };
  backHandler: any;

  componentDidMount() {
    console.debug('PlayerLevelsScreen props: ' + JSON.stringify(this.props));
    AWSManager.trackEvent('PLAYER_LEVELS_SCREEN');
    if (Platform.OS == 'android') {
      this.backHandler = BackHandler.addEventListener('hardwareBackPress', (): boolean => {
        this.props.onBack();
        return true;
      });
    }
    if (!Preferences.get(SKZConstants.SKZ_HAS_SEEN_HOW_TO_LEVEL_UP_MODAL)) {
      this._showHowToLevelUpModal();
    }
  }

  componentWillUnmount() {
    if (this.backHandler) {
      this.backHandler.remove();
    }
  }

  _renderNavigationBar(): React.ReactNode {
    return (
      <NavigationBar
        testID={TEST_IDS.PLAYER_LEVELS_SCREEN_NAVIGATION_BAR}
        hasBackButton={true}
        onBackButtonPress={this.props.onBack}
        title={_m('Levels')}
        titleImage={'ic_info_skz.png'}
        shouldTintTitleImage={true}
        titleImageOnRight={true}
        titleImageSize={styles.titleImageSize}
        titleStyle={styles.titleStyle}
        onTitlePress={this._showHowToLevelUpModal}
      />
    );
  }

  _renderLevelsSection(): React.ReactNode {
    return (
      <View style={styles.listContainerFullWidth}>
        <PlayerLevelsListContainer
          userId={this.props.userId}
          expandedCellOnOpen={this.props.expandedCellOnOpen}
        />
      </View>
    );
  }

  _showHowToLevelUpModal = () => {
    console.log('PlayerLevelsScreen._showHowToLevelUpModal');
    AWSManager.trackEvent('PLAYER_LEVELS_INFO');
    const howToModal = <HowToLevelUpModal testID={TEST_IDS.PLAYER_LEVELS_SCREEN_MODAL} />;
    const howToModalProps = {
      animationType: 'fade',
      transparent: true,
    };
    ModalNavigationController.showModal(howToModal, howToModalProps);
  };

  render(): React.ReactNode {
    return (
      <View testID={TEST_IDS.PLAYER_LEVELS_SCREEN} style={StyleSheet.absoluteFill}>
        {this._renderNavigationBar()}
        <View style={styles.content}>{this._renderLevelsSection()}</View>
      </View>
    );
  }
}

/* eslint-disable no-magic-numbers */
const styles = StyleSheet.create({
  content: {
    backgroundColor: SkillzStyle.convertToOpacity(
      SkillzStyle.fullStyles.viewPrimaryColor.backgroundColor,
      0.85
    ),
    flex: 1,
    ...Sizes.select({
      landscapePhone: {flexDirection: 'row'},
      tablet: {
        borderTopLeftRadius: SkillzStyle.fullStyles.viewCornerRadiusPrimary.borderRadius,
        borderTopRightRadius: SkillzStyle.fullStyles.viewCornerRadiusPrimary.borderRadius,
        overflow: 'hidden',
        width: Sizes._isAndroidSmallTablet() && Sizes.isPortrait() ? Sizes.screenWidth - 24 : 625,
        alignSelf: 'center',
        marginTop: Sizes.select({portrait: 60, landscape: 12}),
      },
      other: {},
    }),
  },

  listContainerFullWidth: {
    flex: 1,
  },

  titleImageSize: {
    height: 20,
    width: 20,
  },

  titleStyle: {
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 6,
    ...Sizes.select({
      phone: {
        fontSize: 20,
      },
      tablet: {
        fontSize: 22,
      },
    }),
  },
});
